import RequestState from 'Enums/RequestState'

export const INITIAL_STATE = {
  fetchTopCitiesRequestState: RequestState.UNINITIALIZED,
  topCities: { data: [] },
  fetchPeakHourRequestState: RequestState.UNINITIALIZED,
  peakHour: {},
  fetchAverageDurationRequestState: RequestState.UNINITIALIZED,
  averageDuration: {},
  fetchTopVouchersRequestState: RequestState.UNINITIALIZED,
  topVouchers: { data: [] },
  fetchTopSitesRequestState: RequestState.UNINITIALIZED,
  topSites: { data: [] },
  fetchOverviewRequestState: RequestState.UNINITIALIZED,
  overview: {},
  fetchTransactionsStatisticsRequestState: RequestState.UNINITIALIZED,
  transactionsStatistics: {},
  fetchUserSignupRequestState: RequestState.UNINITIALIZED,
  userSignup: {},
  fetchTopUsersRequestState: RequestState.UNINITIALIZED,
  topUsers: { data: [] },
  fetchUsersActivityRequestState: RequestState.UNINITIALIZED,
  usersActivity: {},
  fetchUsersStatisticsRequestState: RequestState.UNINITIALIZED,
  usersStatistics: {},
  fetchEnergyChartRequestState: RequestState.UNINITIALIZED,
  energyChart: {},
  fetchTimeForFirstChargeRequestState: RequestState.UNINITIALIZED,
  timeForFirstCharge: {},
  fetchTimeBetweenTransRequestState: RequestState.UNINITIALIZED,
  timeBetweenTrans: {},
  fetchPaymentBreakdownRequestState: RequestState.UNINITIALIZED,
  paymentBreakdown: {},
}
